/* import __COLOCATED_TEMPLATE__ from './clinician-number.hbs'; */
import { classNames, tagName } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './clinician-number.module.scss';

@classic
@tagName('')
@classNames(styles.component)
export default class SharedClinicianNumber extends Component {}
